
import { z } from 'zod';

export const jobSearchFormSchema = z.object({
  industry: z.string().min(1, 'Industry is required'),
  jobRole: z.string().min(1, 'Target Company Profile / Contact Role is required'),
  geography: z.string().min(1, 'Geography is required'),
  keywords: z.string().optional(),
  maxPostedWeeks: z.number().min(1).max(52).optional(),
  providerId: z.string().min(1, 'Provider is required'),
});

export type JobSearchFormData = z.infer<typeof jobSearchFormSchema>;
